<template>
    <div>
        <page-header></page-header>
        <div class="app-root">
            <div class="container">
                <router-view></router-view>
            </div>
        </div>
        <spinner></spinner>
    </div>
</template>

<script>
import PageHeader from "./PageHeader";
import BrandMixin from "../mixins/Brand";
import IframeEventsMixin from "../mixins/IframeEvents";
export default {
    mixins: [BrandMixin, IframeEventsMixin],
    components: { PageHeader },

    props: {
        locale: {
            type: String,
            required: false,
            default: "it",
        },
        translations: {
            type: Object,
            required: false,
            default: () => {
                return {};
            },
        },
    },

    data: function () {
        return {
            clientHeight: document.body.parentElement.offsetHeight,
        };
    },

    provide() {
        return {
            locale: this.locale,
        };
    },

    created() {
        window.translations = this.translations;
    },

    mounted() {
        if (window.parent) {
            this.sendSize();
            setInterval(() => {
                if (
                    this.clientHeight !==
                    document.body.parentElement.offsetHeight
                ) {
                    this.sendSize();
                }
            }, 100);
        }
    },
    methods: {
        sendSize() {
            this.clientHeight = document.body.parentElement.offsetHeight;
            this.sendEvent({
                type: "sizeChange",
                height: this.clientHeight,
            });
        },
    },
};
</script>
